import { Component, OnInit } from "@angular/core";
import { UserService } from "src/app/modules/userModule/shared/user.service";
import { HttpService } from "src/app/modules/assetModule/shared/services/http.service";
import { Audit } from "src/app/models/audit";
import { ConfigService } from "src/app/shared/services/config.service";

@Component({
    selector: 'app-audit',
    templateUrl: './audit.component.html',
    styleUrls: ['./audit.component.css']
})

export class AuditComponent implements OnInit {
    public sortedForm = '';
    public results = 0;
    public audit: Array<Audit>;
    public currentPage = 1;
    public auditElements = [];
    public userEmailId = '';
    public pages = 0;
    public auditDetails: any;
    theme_color: string;
    constructor(private _userService: UserService, private _httpService: HttpService,
        private config: ConfigService) { }

    ngOnInit() {
        let User = JSON.parse(sessionStorage.getItem('userinfo'));
        this.theme_color = User.userSettings.userThemeType===0?'dark':'light';
        this.config.audit = true;
        this.config.changeTabUser(0);
        this.audit = [];
        this.getAuditDetails();
    }

    /**
     * Method to call the api to fetch audit details
     */
    private getAuditDetails() {
        this.userEmailId = this._userService.loggendInUser.userEmailId;
        this._httpService.getBasePath().then(e => {
            this._userService.getAuditDetails(this.userEmailId).subscribe(response => {
                this.auditDetails = response;
                this.createAuditObject();
                this.sort();
            });
        });

    }

    /**
     * Method to create a audit object and an array of audit objects to display in each page in table
     */
    private createAuditObject() {
        this.auditDetails.forEach(audit => {
            audit.auditDetails.forEach(a => {
                const auditDetails = {
                    dateTimeStamp: a.actionDate,
                    userEmailId: audit.userEmailId,
                    assetId: a.assetBundleId,
                    assetName: a.assetBundleName,
                    action: a.action
                };
                this.audit.push(auditDetails);
                this.results = (this.audit.length) - 1;
            });
        });
    }

    /**
     *Method will be called to display 10 records in each page.
     */
    public displayrecodrs() {
        let i = (this.currentPage - 1) * 10;
        for (i; i < this.audit.length; i++) {
            if (this.auditElements.length <= 10) {
                this.auditElements.push(this.audit[i]);
            }
        }
        this.pages = +((this.audit.length - 1) / 10).toFixed();
    }

    /**
     *Method will be called on clicking pf page number to change the pagination
     */
    public selectPage(currentpageNumber: number, event: any) {
        const selectedpageNumber = event.srcElement.__data.currentPage;
        if (currentpageNumber === selectedpageNumber) {
            return;
        } else {
            this.auditElements = [];
            this.currentPage = selectedpageNumber;
            let i = 0;
            i = (selectedpageNumber - 1) * 10;
            for (i; i < this.audit.length; i++) {
                if (this.auditElements.length < 10) {
                    this.auditElements.push(this.audit[i]);
                }
            }
        }
    }

    /**
    *Method will be called to sort the audit elements
    */
    public sort() {
        this.auditElements = [];
        if (this.sortedForm === '' || this.sortedForm === 'ascending') {
            this.sortedForm = 'descending';
            this.audit.sort((a, b) => new Date(b.dateTimeStamp).getTime() - new Date(a.dateTimeStamp).getTime());
        } else {
            this.sortedForm = 'ascending';
            this.audit.sort((a, b) => new Date(a.dateTimeStamp).getTime() - new Date(b.dateTimeStamp).getTime());
        }
        this.displayrecodrs();
    }
}
